import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import {
  fetchUpvoteBlogStatus,
  toggleUpvoteBlog,
} from '../actions/blogUpvoteActions';

const initialState: BlogUpvoteStatusType = {
  total_upvotes: 0,
  user_has_upvoted: false,
  loading: false,
  error: null,
};

const blogUpvoteSlice = createSlice({
  name: 'upvote',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getBlogUpvoteStatus(builder);
    handleUpvoteToggle(builder);
  },
});

const getBlogUpvoteStatus = (
  builder: ActionReducerMapBuilder<BlogUpvoteStatusType>
) => {
  builder.addCase(
    fetchUpvoteBlogStatus.pending,
    (state: BlogUpvoteStatusType) => {
      state.loading = true;
      state.error = null;
    }
  );
  builder.addCase(fetchUpvoteBlogStatus.fulfilled, (state, action) => {
    state.loading = false;
    state.total_upvotes = action.payload.total_upvotes;
    state.user_has_upvoted = action.payload.user_has_upvoted;
  });
  builder.addCase(fetchUpvoteBlogStatus.rejected, (state, { error }) => {
    state.loading = false;
    state.error = error.message || 'Failed to fetch upvotes';
  });
};

const handleUpvoteToggle = (
  builder: ActionReducerMapBuilder<BlogUpvoteStatusType>
) => {
  builder
    .addCase(toggleUpvoteBlog.pending, state => {
      // Optimistic update: flip immediately
      state.user_has_upvoted = !state.user_has_upvoted;
      state.total_upvotes = state.user_has_upvoted
        ? state.total_upvotes + 1
        : state.total_upvotes - 1;
      state.loading = true;
      state.error = null;
    })
    .addCase(toggleUpvoteBlog.fulfilled, (state, action) => {
      state.loading = false;
      state.total_upvotes = action.payload.total_upvotes;
      state.user_has_upvoted = action.payload.user_has_upvoted;
    })
    .addCase(toggleUpvoteBlog.rejected, (state, { error }) => {
      // Revert optimistic update
      state.user_has_upvoted = !state.user_has_upvoted;
      state.total_upvotes = state.user_has_upvoted
        ? state.total_upvotes + 1
        : state.total_upvotes - 1;
      state.loading = false;
      state.error = error.message || 'Failed to toggle upvote';
    });
};

export default blogUpvoteSlice.reducer;
